@let engineerTracking = this.engineerTracking();
@let directionsResult = this.directionsResult();
@let trackingInformationUnavailable = this.trackingInformationUnavailable();

<div class="position-relative bg-body-tertiary full-viewport">
    @if (trackingInformationUnavailable) {
        <sf-tracking-unavailable />
    } @else {
        <div [style.opacity]="engineerTracking ? 1 : 0">
            <div class="position-absolute top-0 start-0 w-100 h-100">
                <google-map #map mapId="map" height="100%" width="100%">
                    @if (directionsResult) {
                        <map-directions-renderer
                            [directions]="directionsResult"
                            [options]="{ markerOptions: { visible: false } }" />
                    }
                </google-map>
            </div>

            <div class="position-absolute start-50 translate-middle-x px-3 w-100" style="top: 4rem; max-width: 350px">
                <div class="card bg-success text-white text-center shadow-sm rounded-pill border-0">
                    <div class="card-body py-2">
                        <strong>Your engineer is on the way</strong>
                    </div>
                </div>
            </div>

            @if (engineerTracking && directionsResult) {
                <sf-tracking-information
                    [engineerTracking]="engineerTracking"
                    [directionsResult]="directionsResult"
                    (onToggleShowInformation)="fitMapBounds($event)" />
            }
        </div>
    }
</div>
